export enum ProductHandle {
  SuperPowerShort = 'superpower-short',
  SuperPowerShortV2 = 'superpower-short-tm',
  SuperPowerBrief = 'superpower-brief',
  QueenBrief = 'queen-brief',
  SuperPowerThong = 'superpower-thong',
  LiftWearTank = 'liftwear-tank',
  LiftWearCami = 'liftwear-cami',
  SilhouetteBra = 'silhouette-bra',
  CrossoverBra = 'crossover-bra',
  BoldnessTank = 'boldness-tank',
  EGiftCard = 'e-gift-card',
  IntimatesBag = 'intimates-bag',
  TapeMeasure = 'tape-measure',
  VNeckBra = 'v-neck-bra',
  WaistHeroCincher = 'waisthero-cincher',
  EverReadyPant = 'everready-pant',
  CamiBodysuit = 'cami-bodysuit',
  EverydayCottonThong = 'everyday-cotton-thong',
  EverydayCottonBrief = 'everyday-cotton-brief',
  LeggingTwo = 'legging-two',
  BoldnessBodysuit = 'boldness-bodysuit',
  SilhouetteBrief = 'silhouette-brief',
  TankBodysuit = 'liftwear-tank-bodysuit',
  SculptwaveCapri = 'sculptwave-capri',
}

Object.freeze(ProductHandle);

export const isProductHandle = (maybeProductHandle: unknown): maybeProductHandle is ProductHandle =>
  Object.values(ProductHandle).includes(maybeProductHandle as ProductHandle);
